export {SymbolScreen as default} from "@features/swing-trading/screens";
